import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IMessageHolder } from "../models/auto-generated";

@Injectable({
  providedIn: "root"
})
export class EventsService {
  private getBaseRoute(instanceId: string): string {
    return `/api/configurations/${instanceId}/events`;
  }
  constructor(private http: HttpClient) {}

  get(instanceId: string): Observable<IMessageHolder[]> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.get<IMessageHolder[]>(baseRoute);
  }
}
